import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { Col, Row } from 'reactstrap';
import { IncentivesEntities } from 'client/data/models/incentives';
import { formatPriceString } from 'client/site-modules/shared/utils/price-utils';
import { INCENTIVE_HEAD_TITLES } from 'site-modules/shared/constants/incentives';

export function IncentiveLeasingInfo({
  incentive: { startDate, endDate, rebateAmount } = {},
  titleType,
  isLast = false,
}) {
  const titles = get(INCENTIVE_HEAD_TITLES, titleType, []);

  return (
    <Fragment>
      <Row tag="dl" noGutters className="mb-0">
        <Col xs={12} md={6}>
          <dt className="fw-medium">{titles[0]}</dt>
          <dd className="fw-bold">{rebateAmount && formatPriceString(rebateAmount)}</dd>
        </Col>
        <Col xs={6} md={3}>
          <dt className="fw-medium">{titles[1]}</dt>
          <dd>{startDate}</dd>
        </Col>
        <Col xs={6} md={3}>
          <dt className="fw-medium">{titles[2]}</dt>
          <dd>{endDate}</dd>
        </Col>
      </Row>
      {!isLast && <hr />}
    </Fragment>
  );
}

IncentiveLeasingInfo.propTypes = {
  incentive: IncentivesEntities.IncentivesGraphql,
  titleType: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
};
